export default __webpack_public_path__ + "src/assets/img/expertise_karte.jpg";